module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/exchange-a4aec6e12f174d440dd6252eb7cdc01e.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/exchange.svg
// module id = S98v
// module chunks = 24